<div class="autocomplete-multiple" *ngIf="control">
    <mat-form-field class="operator" *ngIf="operator">
        <mat-select [formControl]="operator">
            <mat-option value="==" class="autocomplete-multiple-select-operator"> = </mat-option>
            <mat-option value="!=" class="autocomplete-multiple-select-operator"> ≠ </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="auto-complete" [ngClass]="{'show-chips': showShortDisplays}">
        <mat-label> {{label}} </mat-label>
        <mat-select multiple [compareWith]="compareFunction" [formControl]="control" [required]="required"
            (closed)="clearSearch()" panelClass="select-list-fit-content" (openedChange)="openedChange.emit($event)">
            <mat-select-trigger>
                {{control.value?.length ? control.value[0].display : ''}}
                <span *ngIf="control.value?.length > 1">
                    (+{{control.value.length - 1}} {{control.value.length === 2 ?
                    ('shared.components.autocompleteMultiple.other.shortLabel' | translate) :
                    'shared.components.autocompleteMultiple.others.shortLabel' | translate}})
                </span>
            </mat-select-trigger>
            <mat-form-field class="search-control" appearance="fill">
                <mat-label>Search</mat-label>
                <input matInput [formControl]="searchControl" autocomplete="off">
                <button [disableRipple]="true" matSuffix mat-icon-button [disabled]="!searchControl.value"
                    (click)="clearSearch()">
                    <mat-icon aria-label="Clear search">close</mat-icon>
                </button>
            </mat-form-field>

            <div *ngIf="filteredList?.length === 0" class="results">
                {{'shared.components.autocompleteMultiple.noResult.fullLabel' | translate}} </div>
            <div *ngIf="filteredList?.length" class="results">
                {{'shared.components.autocompleteMultiple.results.fullLabel'
                | translate: {results: filteredList.length} }} </div>
            <!-- <cdk-virtual-scroll-viewport itemSize="48"
                                         class="virtual-viewport"> -->
            <app-select-check-all [control]="control" [values]="filteredList" *ngIf="filteredList?.length">
            </app-select-check-all>


            <!-- @for (item of filteredList; track $index) {
                <mat-option [value]="item"
                            class="autocomplete-multiple-select-filtered-item">
                    {{item.display}}
                </mat-option>
            } -->
            @for (item of filteredList; track $index) {
            <mat-option [value]="item" [disabled]="disableCondition ? disableCondition(item) : false"
                class="autocomplete-multiple-select-filtered-item">
                <ng-template *ngIf="customTemplate; else defaultTemplate" 
                    [ngTemplateOutlet]="customTemplate.templateRef" [ngTemplateOutletContext]="{ $implicit: item }">
                </ng-template>
                <ng-template #defaultTemplate>
                    {{ item.display }}
                </ng-template>
            </mat-option>
            }

            <!-- *cdkVirtualFor="let item of filteredList;" -->
            <!-- </cdk-virtual-scroll-viewport> -->
        </mat-select>
    </mat-form-field>
    <div class="selected-values" *ngIf="showShortDisplays">
        <span> {{'shared.components.autocompleteMultiple.selectedOptions.fullLabel' | translate}} </span>
        <mat-chip-listbox class="values-list" *ngIf="control.value?.length">
            <mat-chip-option *ngFor="let value of control.value" class="selected-value"
                [ngClass]="{'disabled': control.disabled}" [matTooltip]="value.display" [disabled]="control.disabled"
                (removed)="removeValue(value)">
                {{value.shortDisplay}}
                <button matChipRemove>
                    <mat-icon class="remove-value">cancel</mat-icon>
                </button>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
    <div *ngIf="showDisplays" class="display-list">
        <span *ngIf="control.value?.length">
            <b> {{'shared.components.autocompleteMultiple.selectedOptions.fullLabel' | translate}} </b>
            <ng-container *ngFor="let value of control.value; index as i">
                {{value.display}} <ng-container *ngIf="i + 1 < control.value.length">, </ng-container>
            </ng-container>
        </span>
    </div>
</div>